/*-------------------------------------------------------------------------------------------------------------------
* about:设备所属房间的选择
* author:马兆铿
* date:2018-1-11
* -------------------------------------------------------------------------------------------------------------------*/
import {updateDevInfo,} from "../../../../api/index";
import {aligenie} from '../../../../utils/tmallGenius'

/*  选择设备名字
* */
class SelectRoom {
  /*  数据列表获取
  * */
  getList() {
    return new Promise((resolve, reject) => {
      resolve(aligenie.roomList)
    });
  }

  /*  改变
  * */
  onChangeFunction(key) {
    return new Promise((resolve, reject) => {
      updateDevInfo({
        m: "updateZone",
        token: sessionStorage.getItem("token"),
        deviceId: this.$route.query.deviceId,
        zone: key
      }).then(res => {
        if (res.status === 0) {
          resolve();
        } else {
          reject();
        }
      }).catch(res => {
        reject();
      });
    });
  }
}

export const selectRoom = new SelectRoom();


// WEBPACK FOOTER //
// ./src/pages/settings/Index_selection/js/room.js